import { render, staticRenderFns } from "./BusStopItem.vue?vue&type=template&id=6962939e&scoped=true&"
import script from "./BusStopItem.vue?vue&type=script&lang=js&"
export * from "./BusStopItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6962939e",
  null
  
)

export default component.exports